import { Schema } from 'rsuite';

const { StringType } = Schema.Types;

const validationModel = Schema.Model({
  name: StringType().isRequired('Name is required.'),
  street: StringType().isRequired('Street is required.'),
  houseNumber: StringType().isRequired('House number is required.'),
  city: StringType().isRequired('City is required.'),
  postcode: StringType().isRequired('Postcode is required.'),
  countryCode: StringType().isRequired('Country is required.'),
});

export default validationModel;
